// istanbul ignore file
import { ContactNumberType } from './tenancies';

enum LandlordAddressType {
    None = 'none',
    Australian = 'australian',
    International = 'international'
}

type LandlordContactNumber = {
    contactNumberId: number;
    number: string;
    type: ContactNumberType;
};

type LandlordLocalAddress = {
    type: LandlordAddressType.Australian;
    addressId: number;
    line1: string;
    line2: string | null;
    line3: string | null;
    suburbId: number;
    suburb: string;
};

type LandlordInternationalAddress = {
    type: LandlordAddressType.International;
    internationalAddress: string;
};

type LandlordNoAddress = {
    type: LandlordAddressType.None;
};

type LandlordAddress = LandlordLocalAddress | LandlordInternationalAddress | LandlordNoAddress;

// GET reqeust
type Landlord = {
    complianceLandlordId: number;
    name: string;
    email: string | null;
    salutation: string | null;
    isIntegrated: boolean;
    address: LandlordAddress;
    contactNumbers: LandlordContactNumber[];
    isMultiLandlord: boolean;
    source: string;
    properties: {
        total: number;
        knownProperties: {
            compliancePropertyId: number;
            address: string;
        }[];
    };
};

type LandlordSearchResponse = Pick<Landlord, | 'name' | 'email' | 'salutation' | 'address' | 'contactNumbers'> & { landlordId: number };

type LandlordAddressUpdate = Omit<LandlordLocalAddress, 'addressId'> & { addressId: number | null } | LandlordInternationalAddress | LandlordNoAddress;

type DraftLandlord = Omit<Landlord, 'isIntegrated' | 'source' | 'complianceLandlordId' | 'address' | 'contactNumbers' | 'isMultiLandlord' | 'properties'>
& { contactNumbers: (Omit<LandlordContactNumber, 'contactNumberId'> & { contactNumberId: number | null })[] }
& { address: LandlordAddressUpdate };

function formatLandlordAddress(address: Landlord['address'] | LandlordAddressUpdate) {
    if (address.type === LandlordAddressType.None) {
        return null;
    }

    if (address.type === LandlordAddressType.International) {
        return address.internationalAddress;
    }

    return [
        address.line1,
        address.line2,
        address.line3,
        address.suburb,
    ].filter((e) => e !== null && e.trim().length !== 0).join(', ');
}

export type {
    Landlord,
    LandlordAddress,
    LandlordContactNumber,
    LandlordInternationalAddress,
    LandlordLocalAddress,
    LandlordNoAddress,
    DraftLandlord,
    LandlordAddressUpdate,
    LandlordSearchResponse,
};
export { LandlordAddressType, formatLandlordAddress };
